import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { selectPartnerAccess } from 'legacy/lut/features/partner360/configuration'
import {
  selectSectionSettings,
  updateSectionSettings,
} from 'legacy/lut/features/partner360/sectionSettings'
import { getSectionSettingValue } from 'legacy/lut/features/partner360/sectionSettings/models/iSectionSettingsState'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getExportPlanActualsValueTypeKey } from 'partner360/helpers/sectionSettings/getExportPlanActualsValueTypeKey'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export const useSavePartnerPlanExportMetric = (
  programType: ProgramTypes,
  partnerId?: string,
  fYear?: number
) => {
  const dispatch = useAppDispatch()
  const settings = useSelector(selectSectionSettings)
  const { isDistributor } = useSelector(selectPartnerAccess)
  return useCallback(
    async ({ metric }: { metric: ActualsValueTypes }) => {
      // The value itself goes under the key that generate reads; the server adds `-user` and `-date`.
      const tag = getExportPlanActualsValueTypeKey(programType, isDistributor)
      if (getSectionSettingValue(settings, tag) === metric) return

      await dispatch(
        updateSectionSettings({
          partnerId,
          fYear,
          flag: tag,
          state: metric,
          saveExtendedInfo: 1,
          controlName: 'Planning',
        })
      ).unwrap()
    },
    [dispatch, fYear, isDistributor, partnerId, programType, settings]
  )
}
